import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { Subject, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { CrmUser } from '@app-models/index';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
@Component({
	selector: 'crm-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
	form: UntypedFormGroup;
	loading = false;
	errorMessage = '';
	successMessage = '';
	getRegisterPending$ = this._store.pipe(select(fromAuth.getRegisterPending));
	getRegisterSuccess$ = this._store.pipe(select(fromAuth.getRegisterSuccess));
	getRegisterError$ = this._store.pipe(select(fromAuth.getRegisterError));
	getRegisterMessage$ = this._store.pipe(select(fromAuth.getRegisterMessage));
	agreeTerms = new UntypedFormControl(false);
	submitted = false;
	// Private
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;
	constructor(
		private _router: Router,
		private _route: ActivatedRoute,
		private _formBuilder: UntypedFormBuilder,
		private _store: Store<fromAuth.AuthState>,
	) {
		// Set the private defaults
		this.form = this._formBuilder.group({
			username: ['', [Validators.required]],
			first_name: ['', [Validators.required]],
			last_name: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(255)]],
			passwordConfirm: ['', [Validators.required, confirmPassword]],
			role_id: [2, [Validators.required]]
		});
		this._unsubscribeAll = new Subject();
	}
	ngOnInit() {
		this.getRegisterPending$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((res) => {
				this.loading = res;
			});
		this.getRegisterSuccess$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((res) => {
				if (!this._viewInited)
					return;
			});
		this.getRegisterError$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((res) => {
				if (!this._viewInited)
					return;
				if (res) {
					this.submitted = false;
					this.errorMessage = res;
				}
			});
		this.getRegisterMessage$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((res) => {
				if (!this._viewInited)
					return;
				if (res) {
					this.successMessage = res;
				}
			});
		this._viewInited = true;
	}
	register() {
		if (this.form.invalid || !this.agreeTerms.value)
			return;
		this.submitted = true;
		this.successMessage = null;
		this.errorMessage = null;
		const value = this.form.value;
		this._store.dispatch(
			new Auth.Register({
				user: {
					username: value.username,
					first_name: value.first_name,
					last_name: value.last_name,
					email: value.email,
					password: value.password,
					role_id: value.role_id
				},
				loginRequired: false, //this.login_flag,
			})
		);
	}
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
function confirmPassword(control: AbstractControl): any {
	if (!control.parent || !control) {
		return;
	}
	const password = control.parent.get('password');
	const passwordConfirm = control.parent.get('passwordConfirm');
	if (!password || !passwordConfirm) {
		return;
	}
	if (passwordConfirm.value === '') {
		return;
	}
	if (password.value !== passwordConfirm.value) {
		return {
			passwordsNotMatch: true,
		};
	}
}
